








































































































































































































































































import { Vue, Component, Prop, Watch } from "@/shared/vuepack";
import {
  FetchState,
  Permission,
  RevealPersonalInformationRequest,
  RevealType,
  InterestRateTableItem
} from "@/shared/types";
import { EmployerFeeSchedule } from "@/employer/types";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import Button from "@/shared/components/ui/Button.vue";
import moment from "moment";
import { EmailHistory } from "@/employer/route-names";
import { custodianDisplayName } from "@/shared/custodianSettingsHelper";
import { formatMMddyyyyDateString } from "@/shared/dateString";
import { formatCurrency } from "@/shared/currency";
import { useContactInfoStore } from "@/shared/store/contactinfo";
import { useUserBankAccountStore } from "@/shared/store/userBankAccount";
import { useUserStore } from "@/shared/store/user";
import { useNotifierStore } from "@/shared/store/notifier";
import { useRevealPersonalInformationStore } from "@/shared/store/revealPersonalInformation";
import { useThemeStore } from "@/shared/store/theme";
import { useUserIdpInformationStore } from "@/employer/store/userIdpInformation";
import { useOpenSearchIndexStore } from "@/admin/store/openSearchIndex";
import { useContributionStore } from "@/shared/store/contribution";
import { useHsaAccountStore } from "@/employer/store/hsabAccounts";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useDeductibleTrackerStore } from "@/employee/store/deductibleTracker";
import { useInterestRateStore } from "@/employer/store/interestRate";
import { useEmployerFeeScheduleStore } from "@/employer/store/employerFeeSchedule";
import { BankCustodian } from "@/admin/types";





@Component({
  components: {
    GenericLoadingSpinner,
    Button
  }
})
export default class AccountHolderDetails extends Vue {
  contactInfoStore = useContactInfoStore();
  userBankAccountStore = useUserBankAccountStore();
  userStore = useUserStore();
  notifierStore = useNotifierStore();
  revealStore = useRevealPersonalInformationStore();
  themeStore = useThemeStore();
  userIdpInformationStore = useUserIdpInformationStore();
  openSearchIndexStore = useOpenSearchIndexStore();
  contributionStore = useContributionStore();
  hsabAccountStore = useHsaAccountStore();
  rolePermissionsStore = useRolePermissionsStore();
  deductibleTrackerStore = useDeductibleTrackerStore();
  interestRateStore = useInterestRateStore();
  employerFeeScheduleStore = useEmployerFeeScheduleStore();

  EmailHistory = EmailHistory;
  formatMMddyyyyDateString = formatMMddyyyyDateString;
  custodianDisplayName = custodianDisplayName;

  editModeIsActive = false;
  emailForm = "";
  isUpdatingEmail = false;
  revealType = RevealType.SocialSecurityNumber;
  reasonComment: string = null;
  showRevealModal = false;
  resyncTalonIsOpen = false;
  resyncTalonInProgress = false;
  resyncTalonDate: string = this.dateOneYearAgo;
  interestRatesModalIsOpen = false;
  employerFeeScheduleModalIsOpen = false;
  hasVerifiedEmailInWex = false;

  @Prop({ required: true })
  username: string;

  @Prop()
  partnerId: number;

  @Prop()
  canEditProfile: boolean;

  @Prop()
  hideButtons: boolean;

  mounted () {
    const args = { username: this.username, partnerId: this.partnerId };
    this.userBankAccountStore.loadBankAccountState(args);
    this.contactInfoStore.getContactInformation(args);
    this.userBankAccountStore.loadHsaAccounts(args);
    this.hsabAccountStore.getHsaAccount(args);
    this.deductibleTrackerStore.loadIsTalonEnabledForUser(args);
  }

  onClickEditMode () {
    this.emailForm = this.email;
    this.editModeIsActive = !this.editModeIsActive;
  }

  onClickSaveEdit () {
    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }

      this.isUpdatingEmail = true;

      this.contactInfoStore.updateUserEmail({
        username: this.username,
        email: this.emailForm,
        partnerId: this.partnerId
      }).then(res => {
        if (res) {
          this.editModeIsActive = !this.editModeIsActive;
          const args = { username: this.username, partnerId: this.partnerId };
          this.contactInfoStore.getContactInformation(args);
          this.userIdpInformationStore.getProfile({
            partnerId: this.partnerId,
            username: this.username,
            force: true
          });
        }
      }).finally(() => {
        this.isUpdatingEmail = false;
        this.hasVerifiedEmailInWex = false;
      });
    });
  }

  onClickCancelEdit () {
    this.hasVerifiedEmailInWex = false;
    this.editModeIsActive = false;
    this.emailForm = this.email;
  }

  onReindex () {
    this.openSearchIndexStore.reindexUser(this.username);
  }

  accountClosedDate (account: any) {
    if (account.isBankAccountDisabled) {
      return formatMMddyyyyDateString(account.lastUpdated);
    }

    return "N/A";
  }

  get hasHsaAccountWithHsaBank () {
    return this.userBankAccountStore.hsaAccounts &&
      this.userBankAccountStore.hsaAccounts.some(a => a.custodian === BankCustodian.HsaBank);
  }

  get allowAutoClaims () {
    if (this.hsabAccountStore.account) {
      const value = this.hsabAccountStore.account.allowAutoClaims;
      return value === true ? "Yes" : "No";
    }
    return "No";
  }

  get canSaveEdit () {
    return this.emailForm !== this.email && !this.$validator.errors.has("email")
        && this.hasVerifiedEmailInWex;
  }

  get coverageLevel () {
    return this.contributionStore.planDetails.planType;
  }

  get hsaEffectiveDate () {
    if (this.contributionStore.planDetails.effectiveDate) {
      return formatMMddyyyyDateString(this.contributionStore.planDetails.effectiveDate);
    }

    return "";
  }

  get ssn () {
    if (this.contactInfoStore.contactInformation.lastFourSsn) {
      return `***-**-${this.contactInfoStore.contactInformation.lastFourSsn}`;
    }

    return "***-**-****";
  }

  get memberNumber () {
    return this.contactInfoStore.contactInformation.memberNumber;
  }

  get lastName () {
    return this.contactInfoStore.contactInformation.lastName;
  }

  get firstName () {
    return this.contactInfoStore.contactInformation.firstName;
  }

  get email () {
    return this.contactInfoStore.contactInformation.email;
  }

  get phoneNumber () {
    return this.contactInfoStore.contactInformation.phoneNumber;
  }

  get mobilePhoneNumber () {
    return this.contactInfoStore.contactInformation.mobilePhoneNumber;
  }

  get physicalAddress () {
    return this.contactInfoStore.contactInformation.physicalAddress;
  }

  get mailingAddress () {
    return this.contactInfoStore.contactInformation.mailingAddress;
  }

  get isMailingSameAsPhysical () {
    return this.contactInfoStore.contactInformation.isMailingSameAsPhysical;
  }

  get dateOfBirth () {
    return moment(this.contactInfoStore.contactInformation.dateOfBirth).format("MMMM DD, YYYY");
  }

  get isLoaded () {
    return this.userBankAccountStore.fetchState === FetchState.Loaded &&
      this.contactInfoStore.contactInformationState === FetchState.Loaded &&
      this.userBankAccountStore.hsaAccountsLoaded &&
      !this.isUpdatingEmail;
  }

  get mothersMaidenName () {
    return this.contactInfoStore.contactInformation.mothersMaidenName;
  }

  showModalSsn () {
    this.revealType = RevealType.SocialSecurityNumber;
    this.showRevealModal = true;
  }

  confirmRevealModal () {
    this.$validator.validate().then(isValid => {
      if (!isValid) {
        return;
      }

      this.showRevealModal = false;

      const revealFormModel: RevealPersonalInformationRequest = {
        reason: this.reasonComment,
        revealType: this.revealType,
        revealForUserName: this.username
      };

      this.revealStore.revealPersonalInformation(revealFormModel).then()
        .catch(err => {
          if (err && err.message) {
            this.notifierStore.setDanger(err.message);
          }
        });
    });
  }

  hideModalAndStopEdit () {
    this.showRevealModal = false;
    this.reasonComment = null;
  }

  get showRevealSsn () {
    return this.userStore.hasRevealAccess;
  }

  get revealedInfo () {
    return this.revealStore.revealedInformation;
  }

  @Watch("revealedInfo")
  onSensitiveInformationChange () {
    this.reasonComment = null;

    if (this.revealStore.revealedInformation && this.revealStore.revealedInformation.sensitiveInformation) {
      this.notifierStore.setSuccess(
        `${this.revealStore.revealedInformation.revealType} for ${this.firstName} ${this.lastName} is ${this.revealStore.revealedInformation.sensitiveInformation}`);
      this.revealStore.finishedViewingInformation();
    }
  }

  get canResyncTalonClaims (): boolean {
    return !this.resyncTalonInProgress
      && this.talonIsEnabledForCustomer
      && this.rolePermissionsStore.userHasPartnerPermission(Permission.ResyncMyMedicalShopperClaims, this.partnerId);
  }

  get dateOneYearAgo (): string {
    return moment().subtract(1, "y").format("MM/DD/YYYY");
  }

  onCloseRescyncTalon () {
    this.resyncTalonIsOpen = false;
  }

  onResyncTalonModal () {
    this.resyncTalonDate = this.dateOneYearAgo;
    this.resyncTalonIsOpen = true;
  }

  resyncTalonClaims () {
    this.userStore.resyncTalonClaims({ cognitoUsername: this.username, resyncDate: this.resyncTalonDate, partnerId: this.partnerId })
      .catch(err => {
        if (err && err.message) {
          this.notifierStore.setDanger(err.message, 5000);
        }
      });
  }

  get talonIsEnabledForCustomer (): boolean {
    return this.deductibleTrackerStore.isHealthPlanIsLinkedLoaded
      && this.deductibleTrackerStore.healthPlanIsLinked;
  }

  onTalonResync () {
    this.resyncTalonInProgress = true;
    this.resyncTalonIsOpen = false;
    this.resyncTalonClaims();
    this.resyncTalonDate = this.dateOneYearAgo;
  }

  get interestRatesLoading () {
    return this.interestRateStore.fetchState === FetchState.Loading;
  }

  get interestRatesFailed () {
    return this.interestRateStore.fetchState === FetchState.Failed;
  }

  get interestRates (): InterestRateTableItem[] {
    return this.interestRateStore.getInterestRatesAsTableData;
  }

  onShowInterestRatesModal () {
    this.interestRateStore.loadInterestRates({ username: this.username, partnerId: this.partnerId });
    this.interestRatesModalIsOpen = true;
  }

  onCloseInterestRatesModal () {
    this.interestRatesModalIsOpen = false;
  }

  get employerFeeScheduleLoading () {
    return this.employerFeeScheduleStore.fetchState === FetchState.Loading;
  }

  get employerFeeScheduleFailed () {
    return this.employerFeeScheduleStore.fetchState === FetchState.Failed;
  }

  get employerFeeSchedules () {
    return this.employerFeeScheduleStore.getEmployerFeeSchedulesAsTableItems;
  }

  onShowEmployerFeeScheduleModal () {
    let offeringId = 0;

    if (this.hsabAccountStore.account) {
      offeringId = this.hsabAccountStore.account.offeringId;
    }

    this.employerFeeScheduleStore.loadEmployerFeeSchedules({ username: this.username, partnerId: this.partnerId, offeringId });
    this.employerFeeScheduleModalIsOpen = true;
  }

  onCloseEmployerFeeScheduleModal () {
    this.employerFeeScheduleModalIsOpen = false;
  }

}
